import type { ReactNode } from "react";

export interface NotificationGroupProps {
  title: string;
  /** One line explaining what the events in this group have in common. */
  description?: string;
  children: ReactNode;
}

/**
 * A titled band of notification cards. Used where one product covers more than one family of events — the
 * collections page carries Bre-B and the other rails as separate groups, because Bre-B is reached through its
 * own key rather than through a collection someone created.
 */
export function NotificationGroup({ title, description, children }: NotificationGroupProps) {
  return (
    <section className="flex flex-col gap-3">
      <div>
        <h2 className="text-[15px] font-semibold tracking-[-0.01em] text-foreground">{title}</h2>
        {description && <p className="mt-0.5 text-[12.5px] text-muted-foreground">{description}</p>}
      </div>
      <div className="flex flex-col gap-3">{children}</div>
    </section>
  );
}
